import { useEffect, useRef, useState } from "react";
import API from "../api/api";

export default function Footer() {
  const [popular, setPopular] = useState([]);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const fetched = useRef(false);

  // Fetch popular posts
  useEffect(() => {
    if (fetched.current) return;
    fetched.current = true;

    API.get("/articles/popular?range=week")
      .then((res) => {
        if (Array.isArray(res.data)) {
          setPopular(res.data.slice(0, 3));
        }
      })
      .catch((err) =>
        console.error("Footer popular error:", err)
      );
  }, []);

  // Newsletter subscribe
  const handleSubscribe = async () => {
    if (!email) {
      setMessage("Please enter a valid email.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const res = await API.post("/newsletter/subscribe", { email });
      setMessage(res.data.message || "Subscribed successfully!");
      setEmail("");
    } catch {
      setMessage("Subscription failed. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-[#1d1d1f] text-gray-300 pt-12 pb-6 px-6">

      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">

        {/* ABOUT */}
        <div>
          <img
            src="/logo.png"
            alt="TechArticleHub logo"
            width="220"
            height="64"
            loading="lazy"
            className="mb-4 object-contain"
          />

          <p className="text-gray-400 text-sm leading-relaxed">
            <strong>techarticlehub</strong> is a developer-focused platform
            delivering high-quality tutorials, AI insights, and real-world
            programming guides.
          </p>
        </div>

        {/* MOST VIEWED */}
        <div>
          <h3 className="text-lg font-semibold mb-4">
            Most Viewed Posts
          </h3>

          <div className="space-y-5">
            {popular.length === 0 && (
              <p className="text-sm text-gray-500">Loading articles…</p>
            )}

            {popular.map((post) => (
              <a
                key={post.id}
                href={`/article/${post.slug}`}
                className="flex gap-3 group"
              >
                <img
                  src={post.images || "/placeholder.jpg"}
                  alt={post.title}
                  className="w-24 h-16 rounded object-cover border"
                  loading="lazy"
                  onError={(e) => (e.target.src = "/placeholder.jpg")}
                />

                <p className="text-sm font-medium group-hover:text-white line-clamp-2">
                  {post.title}
                </p>
              </a>
            ))}
          </div>
        </div>

        {/* NEWSLETTER */}
        <div>
          <h3 className="text-lg font-semibold mb-4">
            Join Our Newsletter
          </h3>

          <div className="flex">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email address"
              className="p-2 rounded-l bg-transparent border border-gray-600 text-white w-full"
            />

            <button
              onClick={handleSubscribe}
              disabled={loading}
              className="bg-purple-600 px-6 rounded-r hover:bg-purple-700 disabled:opacity-50"
            >
              {loading ? "..." : "Subscribe"}
            </button>
          </div>

          {message && (
            <p className="text-sm mt-2 text-green-400">
              {message}
            </p>
          )}
        </div>
      </div>

      {/* BOTTOM FOOTER */}
      <div className="border-t border-gray-700 mt-10 pt-6 text-sm">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">

          <p className="text-gray-400">
            © 2025 <strong>techarticlehub</strong> — All Rights Reserved.
          </p>

          <nav className="flex flex-wrap gap-4">
            <a href="/about" className="hover:text-white">About</a>
            <a href="/contact" className="hover:text-white">Contact</a>
            <a href="/terms-conditions" className="hover:text-white">Terms</a>
            <a href="/privacy-policy" className="hover:text-white">Privacy</a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
